import { Box, Button, InputAdornment, Paper, SxProps, Theme } from "@mui/material";
import React from "react";
import { IconPickerButton } from "../../../components/IconPicker";
import { AbstractTypedDataForm } from "../../../components/data/DataForm";
import DatePicker from "../../../components/form/DatePicker";
import { FormNumberInput, FormTextInput } from "../../../components/form/TextInput";
import { Tariff } from "../../../models/Types";
import { isMobile } from "../../../utils";
import { tariffStore } from "./TariffCombo";

export function tariffParse(d?: any) {
    const dto = (d || {}) as Tariff;
    d?.StartDate && (dto.StartDate = new Date(d.StartDate));
    return dto;
}


export class TariffForm extends AbstractTypedDataForm<Tariff> {
    private ki = 0;

    protected getTypeName(): React.ReactNode {
        return 'Тариф';
    }

    protected getFormStyle(): SxProps<Theme> | undefined {
        return {
            ...this.props.sx,
            flexDirection: 'row',
            alignItems: 'flex-start'
        };
    }

    buildButtons() {
        return [];
    }

    onSave() {
        tariffStore.clear();
        return super.onSave();
    }

    onAfterDelete() {
        tariffStore.clear();
        return super.onSave();
    }

    protected getTypeId(): string {
        return 'Tariff';
    }

    protected createEntity() {
        return tariffParse();
    }

    protected buildItems(entity?: Tariff | undefined): React.ReactNode {
        return <>
            <Paper sx={isMobile() ? { flex: 1 } : { minWidth: 500 }}>
                <FormTextInput key={`Name-${this.ki}`} required={true} label="Наименование" name="Name" form={this} entity={entity}
                    inputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconPickerButton defaultIcon="grid" value={entity?.Icon} onChange={v => this.onFieldChange('Icon', v)} />
                        </InputAdornment>
                    }} />
                <FormTextInput key={`Unit-${this.ki}`} required={true} label="Единицы измерения" name="Unit" form={this} entity={entity} />
                <FormNumberInput key={`Price-${this.ki}`} required={true} label="Стоимость за единицу" name="Price" form={this} entity={entity} />
                <FormNumberInput key={`Norm-${this.ki}`} required={true} label="Норма" name="Norm" form={this} entity={entity} />
                <DatePicker label="Начало действия тарифа" value={entity?.StartDate} onChange={v => entity!.StartDate = v?.toDate() || new Date()} />

                <Box sx={{ display: 'flex' }}>
                    <div style={{ flex: 1 }} />
                    <Button variant="contained" type="submit">Сохранить</Button>
                </Box>
            </Paper>
        </>;
    }
}